// test1009
(1009 && 0);
